import { useState } from 'react';
import { Dialog, IconButton, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { CloseIcon } from '../Icon';
import { i18n } from '../../language';
import { Login } from '.';

const useStyle = makeStyles(() => ({
  dialog: {
    '& .MuiPaper-rounded': {
      marginTop: '-2.5rem',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.393rem 0.75rem rgba(0, 0, 0, 0.04)',
    },
  },
  dialogIcon: {
    fontSize: '1rem',
    color: '#5f9df6',
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  btn: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
}));

const LoginPop = ({ closehandle, submitHandle, tokenExpiration = false }) => {
  const classes = useStyle();
  const loginInfo = useSelector((state) => state.loginInfo);
  const [open, setOpen] = useState(tokenExpiration ? true : !loginInfo.flag);
  const handleClose = () => {
    setOpen(false);
    if (typeof closehandle === 'function') {
      closehandle();
    }
  };
  return open ? (
    <Dialog open={open} className={classes.dialog}>
      <Login button={i18n.t('EHANDOVER_LOGIN_BUTTON')} submitClick={submitHandle}>
        <div className={classes.btn}>
          <IconButton
            id="login_pop_close"
            style={{
              margin: '0px -10px 0 0',
            }}
            onClick={handleClose}
          >
            <CloseIcon className={classes.dialogIcon} />
          </IconButton>
        </div>
      </Login>
    </Dialog>
  ) : null;
};

export default LoginPop;
